/**
 * Simple AJAX Service for Departure Date Manager
 *
 * Handles AJAX communication with WordPress backend using best practices.
 */
export default class AjaxService {
	/**
	 * Make AJAX request to WordPress
	 * @param {string} action - AJAX action name
	 * @param {Object} data - Data to send
	 * @returns {Promise<Object>} Response data
	 */
	async request( action, data = {} ) {
		if ( ! action ) {
			throw new Error( 'Action is required' );
		}

		if ( ! window.ddm_ajax?.nonce ) {
			throw new Error( 'Nonce not available' );
		}

		const formData = new FormData();
		formData.append( 'action', action );
		formData.append( 'nonce', window.ddm_ajax.nonce );

		// Add data to form
		Object.entries( data ).forEach( ( [ key, value ] ) => {
			if ( value != null ) {
				formData.append( key, value );
			}
		} );

		try {
			const response = await fetch( window.ddm_ajax.ajax_url, {
				method: 'POST',
				body: formData,
			} );

			if ( ! response.ok ) {
				throw new Error( `HTTP ${ response.status }` );
			}

			return await response.json();
		} catch ( error ) {
			throw new Error( `AJAX request failed: ${ error.message }` );
		}
	}

	/**
	 * Filter departure dates
	 * @param {Object} params - Filter parameters
	 * @returns {Promise<Object>} Filtered results
	 */
	async filterDepartures( params ) {
		return this.request( 'ddm_filter_departures', params );
	}

	/**
	 * Load filtered content
	 * @param {Object} params - Content parameters
	 * @returns {Promise<Object>} Content data
	 */
	async loadFilteredContent( params ) {
		return this.request( 'ddm_load_filtered_content', params );
	}
}
